import FlightIcon from "../../assets/images/flight.png";
import handShake from "../../assets/images/handshake.png";
import Satisfy from "../../assets/images/satisfaction.png";
import waiting from "../../assets/images/waiting.png";
import style from "./WhatWeDo.module.scss";

const WhatWeDo = () => {
  return (
    <div className={style.wedo}>
      <div className="container">
        <h2>Our Promises - Executive Chauffeur Service London</h2>

        <div className={`${style.wedo__row} flex-wrap`}>
          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={FlightIcon} alt="professional_chauffeur_service_london" />
              </picture>

              <strong>Professionalism</strong>
              <p>
                Our Professional Chauffeur Service London is not just about
                doing the job — it's about how well it is done. We strive to
                constantly provide the best luxury car service with driver
                London, ensuring absolute satisfaction on every job, big or
                small.
              </p>
            </div>
          </div>
          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={handShake} alt="luxury_car_service_driver_london" />
              </picture>
              <strong>Transparent Pricing</strong>
              <p>
                Our prices for chauffeur driven car service London are fixed and
                completely transparent, with no hidden extras. We have
                strategically placed ourselves in the centre of the minicab and
                chauffeuring market with the best of both worlds at reasonable,
                affordable costs.
              </p>
            </div>
          </div>
          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={waiting} alt="premium_chauffeur_rides_london" />
              </picture>
              <strong>Reliability</strong>
              <p>
                Reliability is the most important pillar of our Premium
                Chauffeur Rides London service. To us, a minute late is late! We
                will always be at your requested location of pickup on-time, for
                whenever you are ready.
              </p>
            </div>
          </div>

          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={Satisfy} alt="private_chauffeur_service_london" />
              </picture>
              <strong>100% Satisfaction!</strong>
              <p>
                Our Private Chauffeur Service London has a long-standing
                commitment to provide respect, support and VIP treatment to all
                our customers. We are confident that our Executive Chauffeur
                Service London can meet and exceed your expectations.
              </p>
            </div>
          </div>

          {/* <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={CarIcon} alt="airport_shuttle" />
              </picture>
              <strong>MEETING YOU ON ARRIVAL</strong>
              <p>
                Your driver will be waiting for you holding a sign with your
                name on at our meeting point at Airport when you arrive. We use
                several flight monitoring systems and we will be aware if your
                flight is delayed or due to arrive early. You can enjoy your
                flight in the knowledge that we will be waiting for you at the
                correct time of arrival.
              </p>
            </div>
          </div>
          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={CarIcon} alt="airport_shuttle" />
              </picture>
              <strong>FREE BOOSTER SEATS </strong>
              <p>
                In need of a booster for your little one? Not to worry we supply
                booster seats free of charge.
                <br />
                Child seats are also available.
              </p>
            </div>
          </div>
          <div className={style.wedo__item}>
            <div className={style.wedo__card}>
              <picture>
                <img src={CarIcon} alt="airport_shuttle" />
              </picture>
              <strong>CLIENT ORIENTED SERVICE </strong>
              <p>
                Professional & reliable service for all occasions. We provide
                client orientated service meaning bespoke tailor made bookings
                adapted to your needs and requirements. Your first choice for
                airport transfers, long distance travel & chauffeur services.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default WhatWeDo;
